import { defineComponent as _defineComponent } from 'vue'
import RepositoryErrorHandler from "@/services/RepositoryErrorHandler"
import useNotification from "@/logics/useNotification"



export default /*#__PURE__*/_defineComponent({
  name: 'AppMain',
  setup(__props, { expose }) {
  expose();

const notification = useNotification();

RepositoryErrorHandler.handle = (msg) => {
  notification.showError(msg);
};


const __returned__ = { notification }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})